import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';
import { isViewableImage, uploadedDocumentUrl } from '../uploaded-document-url';

/** Fields common to every permit type - reused by each per-type detail view. */
@Component({
    selector: 'app-permit-common-details',
    templateUrl: './permit-common-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PermitCommonDetailsComponent {
    @Input() permit!: PermitDetail;

    /** Served through the backend, not straight off the bucket - see the helper. */
    public readonly documentUrl = uploadedDocumentUrl;
    /** The holder photo renders inline; anything else stays a link. */
    public readonly isImage = isViewableImage;
    /**
     * Set false for permit types that don't have a location at all - fishing and
     * hunting are scoped by clan area instead, so the row would only ever read "-".
     */
    @Input() showLocation = true;
    /**
     * Heading for the other-people row. Defaults to "Party"; a research permit passes
     * "Research team" so the same list reads correctly for its type.
     */
    @Input() membersLabel = 'Party';

    /** How many places the permit names, counting a free-text "Other" as one. */
    public get locationCount(): number {
        return (this.permit.locations?.length ?? 0) + (this.permit.locationOther ? 1 : 0);
    }
}
